import auth from '@wetransfer/transfer/auth-bundle/store/reducer';
import { currentOrderReducer } from '@wetransfer/transfer/store/currentOrder';
import { customWallpapersReducer } from '@wetransfer/transfer/store/customWallpapers';
import { paymentIntegrationsReducer } from '@wetransfer/transfer/store/paymentIntegrations';
import uploadNotifications from '@wetransfer/transfer/store/reducer/upload-notifications';
import { transferWindowDrawerSlice } from '@wetransfer/transfer/store/transferWindowDrawer';
import transferUpload from '@wetransfer/transfer/transfer-bundle/store/reducer';

import account from './account';
import apiGrants from './apigrants';
import billingDetails from './billingdetails';
import channel from './channel';
import consent from './consent';
import contacts from './contacts';
import download from './download';
import errors from './errors';
import invoices from './invoices';
import layout from './layout';
import notification from './notification';
import pending from './pending';
import route from './route';
import session from './session';
import transfer from './transfer';
import transfers from './transfers';
import transfersReceived from './transfers-received';
import ui from './ui';
import upload from './upload';
import user from './user';

export default {
  channel,
  contacts,
  download,
  errors,
  layout,
  notification,
  pending,
  route,
  session,
  transfer,
  transfers,
  transfersReceived,
  upload,
  user,
  account,
  ui,
  invoices,
  apiGrants,
  billingDetails,
  transferUpload,
  consent,
  auth,
  customWallpapers: customWallpapersReducer,
  paymentIntegrations: paymentIntegrationsReducer,
  currentOrder: currentOrderReducer,
  uploadNotifications,
  transferWindowDrawer: transferWindowDrawerSlice.reducer,
};
